import React, { ReactElement } from 'react';
import { editActions } from '../../../../../redux/admin/edit/actions';
import { Card, CardHeader } from '../../../../common/pov-common-ui';
import AddContentForm from './add-content-form';
import DemoContentTable from './demo-content-table';
import './styles.scss';

export interface ContentProps {
  value?: string;
  errors: string[];
  demoContent?: FormattedDemoContent;
  isPublished?: boolean;
  disableValidate: boolean;
  setCsvValue: typeof editActions.setCsvValue;
  showCheckCapacity: boolean;
  disableCheckCapacity: boolean;
  validating: boolean;
  validate: typeof editActions.validateCsv;
  checkCapacity: typeof editActions.checkCapacity;
  isCapacityChecked: boolean;
  capacityDetail: IFormattedCapacityContent[];
}

const Content = ({
  value,
  errors,
  validating,
  demoContent,
  isPublished,
  disableValidate,
  setCsvValue,
  showCheckCapacity,
  disableCheckCapacity,
  validate,
  checkCapacity,
  isCapacityChecked,
  capacityDetail,
}: ContentProps): ReactElement => {
  const callValidate = React.useCallback(() => {
    if (!value) return;
    validate();
  }, [value, validate]);

  return (
    <Card className="content-card" loading={validating}>
      <CardHeader title="Content" alignTitle="center" />
      <AddContentForm
        csvErrors={errors}
        csvContent={value}
        disableContentInput={isPublished}
        disableValidate={disableValidate}
        setCsvValue={setCsvValue}
        validate={callValidate}
      />
      {demoContent && (
        <DemoContentTable
          data={demoContent}
          showCheckCapacity={showCheckCapacity}
          disableCheckCapacity={disableCheckCapacity}
          checkCapacity={checkCapacity}
          isCapacityChecked={isCapacityChecked}
          capacityDetail={capacityDetail}
        />
      )}
    </Card>
  );
};

export default Content;
